<template>
  <aw-cms-page v-if="contentData" :content-data="contentData" :class="$style.page" />
</template>

<script setup lang="ts">
  import { computed, defineAsyncComponent, onBeforeUnmount, onMounted } from 'vue';
  import { useContentsStore } from '~~/common/stores/contents';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  const AwCmsPage = defineAsyncComponent(() => import('~~/common/components/Page/Content/AwCmsPage.vue'));

  defineOptions({
    name: 'ShopIndex',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  const STATIC_CONTENT_TYPE = 'homepage';

  const contentsStore = useContentsStore();
  const userInterfaceStore = useUserInterfaceStore();

  const contentData = computed(() => contentsStore.staticContent[STATIC_CONTENT_TYPE]);

  onMounted(() => {
    contentsStore.increaseStaticContentUsers({ type: STATIC_CONTENT_TYPE });
    if (contentData.value) {
      userInterfaceStore.setBackground({ ...contentData.value });
    }
  });
  onBeforeUnmount(() => {
    contentsStore.decreaseStaticContentUsers({ type: STATIC_CONTENT_TYPE });
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.page {
  padding-bottom: 20px;

  @include tablet(min) {
    padding-bottom: 40px;
  }
}
</style>
